import { StoryblokComponent, storyblokEditable } from "@storyblok/react";
import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { AlignJustify, X } from "lucide-react";
import { useOnOutsideClick } from "../hooks/useOnOutsideClick";
import { Portal } from "./Portal";
import { AnimatePresence, motion } from "motion/react";

const Config = ({ blok }) => {
  const [showMobile, setShowMobile] = useState(false);

  return (
    <div
      className={`menu-wrapper ${showMobile ? "open" : ""}`}
      {...storyblokEditable(blok)}
    >
      <div className="menu-inner max-w-7xl mx-auto px-4 sm:px-6">
        <div className="menu-x-inner flex justify-between items-center  py-6 md:justify-start md:space-x-10">
          <div className="logo-wrapper justify-start lg:w-0 lg:flex-1">
            <Link to="/">
              <img
                className="h-20 w-auto sm:h-10 menu-logo"
                src={blok.CatalystLogo.filename}
                alt=""
              />
            </Link>
          </div>

          <div className={`mainmenu-wrapper closed`}>
            {blok.menu.map((nestedBlok) => (
              <StoryblokComponent
                className=""
                blok={nestedBlok}
                key={nestedBlok._uid}
                setShowMobile={setShowMobile}
              />
            ))}
          </div>
          <AnimatePresence>
            {showMobile ? (
              <MobileMenu
                blok={blok}
                showMobile={showMobile}
                setShowMobile={setShowMobile}
              />
            ) : null}
          </AnimatePresence>
          <button
            type="button"
            onClick={() => setShowMobile((prevValue) => !prevValue)}
            className="mobile-menu-button"
          >
            {showMobile ? (
              <X alt="Close menu" size={20} />
            ) : (
              <AlignJustify alt="Show menu" size={20} />
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

const MobileMenu = ({ blok, showMobile, setShowMobile }) => {
  const [focusTrapped, setFocusTrapped] = useState(false);

  const modalRef = useRef(null);

  useOnOutsideClick(modalRef, () => setShowMobile(false));

  useEffect(() => {
    function keyListener(e) {
      const listener = keyListenersMap.get(e.key);
      return listener && listener(e);
    }

    document.addEventListener("keydown", keyListener);

    return () => document.removeEventListener("keydown", keyListener);
  });

  const handleTabKey = (e) => {
    console.log("made it here");
    if (showMobile && modalRef.current) {
      const focusableModalElements = modalRef.current.querySelectorAll(
        'a[href], button, textarea,   input[type="text"], input[type="radio"], input[type="checkbox"], select'
      );
      const firstElement = focusableModalElements[0];
      const lastElement =
        focusableModalElements[focusableModalElements.length - 1];

      console.log("yup", focusTrapped, firstElement);
      if (!focusTrapped) {
        if (
          Array.from(focusableModalElements).find(
            (e) => e === document.activeElement
          )
        ) {
          setFocusTrapped(true);
        } else if (firstElement) {
          firstElement.focus();
          setFocusTrapped(true);
        }
      }

      if (focusableModalElements.length === 1) {
        firstElement.focus();
        return e.preventDefault();
      }

      if (!e.shiftKey && document.activeElement === lastElement) {
        firstElement.focus();
        return e.preventDefault();
      }

      if (e.shiftKey && document.activeElement === firstElement) {
        lastElement.focus();
        e.preventDefault();
      }
    }
  };

  const keyListenersMap = new Map([
    ["Escape", () => setShowMobile(false)],
    ["Tab", handleTabKey],
  ]);

  return (
    <Portal scrollLock>
      <motion.div
        className="mainmenu-mobile-wrapper menu-x-inner"
        ref={modalRef}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <div className="mainmenu-mobile-top">
          <div className="logo-wrapper justify-start lg:w-0 lg:flex-1">
            <Link to="/">
              <img
                className="h-20 w-auto sm:h-10 menu-logo"
                src={blok.CatalystLogo.filename}
                alt=""
              />
            </Link>
          </div>
          <button
            type="button"
            onClick={() => setShowMobile((prevValue) => !prevValue)}
            className="mobile-menu-button"
          >
            {showMobile ? (
              <X alt="Close menu" size={20} />
            ) : (
              <AlignJustify alt="Show menu" size={20} />
            )}
          </button>
        </div>
        <div className={`mainmenu-wrapper open`}>
          {blok.menu.map((nestedBlok) => (
            <StoryblokComponent
              className=""
              blok={nestedBlok}
              key={nestedBlok._uid}
              setShowMobile={setShowMobile}
            />
          ))}
        </div>
      </motion.div>
    </Portal>
  );
};

export default Config;
